import Checkbox from 'components/checkbox'
import Dialog from "material-ui/Dialog";
import MenuItem from "material-ui/MenuItem";
import SelectField from 'material-ui/SelectField'
import PropTypes from "prop-types";
import { Component } from "react";
import intl from 'react-intl-universal'
import {
  ListStatusCancellationSupplierApproval,
  ListStatusCancelNoticeSupplier,
} from "../../models/pedidos/statusPedido";
import './danger-dialog.css'
import Button from "components/button";
import Loading from 'components/center-loading';
import TextArea from "components/textarea";
import { GeneralSettingParameter } from "models/generalSetting/generalSetting";
import SessionUser from 'utils/user-storage';
import Feature from "../feature";
import { perfilPermissaoCancelamentoForcado } from "./utils";

class DangerDialog extends Component {
  constructor(props) {
    super(props)

    this.state = {
      show: props.show,
      selectedMessage: this.getDefaultJustificationMessage(),
      messageError: 'Selecione uma Justificativa',
      messageUser: '',
      caseInCancellation: 0,
      forcedCancel: false,
    }
  }

  componentDidMount() {
    this.setState({
      caseInCancellation: this.validateCaseCancellationInProgress()
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({ show: this.props.show });
    }

    if (prevProps.statusPedidoEmCancelamento !== this.props.statusPedidoEmCancelamento) {
      const caseInCancellation = this.validateCaseCancellationInProgress();
      this.setState({ caseInCancellation });
    }

    if (
      prevProps.justificationMessages !== this.props.justificationMessages &&
      this.props.justificationMessages &&
      this.props.justificationMessages.length > 0 &&
      this.state.selectedMessage === 0
    ) {
      const defaultMessage = this.getDefaultJustificationMessage();
      this.setState({ selectedMessage: defaultMessage });
    }
  }

  _onRequestClose = () => {
    this.setState({
      show: false
    })
  }

  _onClick = () => {
    const { caseInCancellation, selectedMessage, messageUser, forcedCancel } = this.state;
    const { handleConfirmRequestOrderCancellation, handleConfirm } = this.props;
    if (caseInCancellation === 2) {
      handleConfirmRequestOrderCancellation(selectedMessage, messageUser, forcedCancel);
    }
    else {
      handleConfirm(selectedMessage, messageUser, forcedCancel)
    }
  }

  _onCancelClick = () => {
    this.setState({
      selectedMessage: this.getDefaultJustificationMessage(),
      messageUser: ''
    })
    this.props.handleClose()
  } 

  validateCaseCancellationInProgress = () => {
    const { statusPedidoEmCancelamento } = this.props;
    switch (true) {
      case ListStatusCancelNoticeSupplier.some(orderStatus => orderStatus === statusPedidoEmCancelamento):
        return 1
      case ListStatusCancellationSupplierApproval.some(orderStatus => orderStatus === statusPedidoEmCancelamento):
        return 2
      default:
        return 0
    }
  }

  _onChange = (_selectedValues, _idx, value) => {
    const selectedMessage = value
    this.setState({ selectedMessage })
  }

  _onChangeCheckedForcedCancel = (e) => {
    this.setState({ forcedCancel: e.target.checked })
  }

  handleMessageUser = (e) => {
    this.setState({
      messageUser: e.target.value
    })
  }

  getDefaultJustificationMessage = () =>
    this.props.justificationMessages && this.props.justificationMessages.length > 0 ? this.props.justificationMessages[0].Key : 0

  render() {
    const { title, labelButton, labelButtonClose, justificationMessages, isLoading } = this.props;
    const { show, selectedMessage, caseInCancellation } = this.state;

    return (
      <Dialog
        open={show}
        title={title}
        contentStyle={{ width: '455px' }}
        onRequestClose={this._onRequestClose}
      >
        <div className="container-dialog-danger">
          {caseInCancellation > 0 &&
            <div className='warning-message-wrapper'>
              <p className='title-warning-message'>{intl.get(`stocks.stockDetail.dangerDialog.warningTitleCase${caseInCancellation}`)}</p>
              <p className='description-warning-message'>{intl.get(`stocks.stockDetail.dangerDialog.warningDescriptionCase${caseInCancellation}`)}</p>
            </div>
          }
          <div className='select-dropdown'>
            <SelectField
              floatingLabelText={intl.get('stocks.suggestionsListItem.justification')}
              value={selectedMessage}
              onChange={this._onChange}
              fullWidth={true}
            >
              {justificationMessages?.map((v) => (
                <MenuItem value={v.Key} key={v.Key} primaryText={v.Value} />
              ))}
            </SelectField>
          </div>
          {caseInCancellation > 0 &&
            <TextArea
              label={intl.get('stocks.stockDetail.dangerDialog.messageToSupplier')}
              name="messageUser"
              value={this.state.messageUser}
              onChange={this.handleMessageUser}
            />
          }
          {(perfilPermissaoCancelamentoForcado.includes(SessionUser.get().PerfilAcesso)) &&
            <Feature hideFlags={GeneralSettingParameter.LoadCompositionNewFlow}>
              <div style={{ zIndex: 2 }}>
                <Checkbox
                  text={intl.get('stocks.stockDetail.dangerDialog.forcedCancel')}
                  name="forced-checkbox"
                  checked={this.state.forcedCancel}
                  onChange={this._onChangeCheckedForcedCancel}
                />
              </div>
            </Feature>
          }
          <div className="dialog-danger-button-container">
            <Button
              value={labelButtonClose}
              buttonType="default"
              onClick={this._onCancelClick}
              style={{ width: '166px' }}
              className="button__danger-dialog"
            />
            <Button
              value={labelButton}
              buttonType="danger"
              onClick={this._onClick}
              style={{ width: '166px' }}
              className="button__danger-dialog"
            />
          </div>
          <div className="testeLoad">
            <Loading isLoading={isLoading} fullHeightParent />
          </div>
        </div>
      </Dialog>
    )
  }
}

DangerDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  justificationMessages: PropTypes.array.isRequired,
  labelButton: PropTypes.string.isRequired,
  labelButtonClose: PropTypes.string.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleConfirmRequestOrderCancellation: PropTypes.func,
  statusPedidoEmCancelamento: PropTypes.number,
  isLoading: PropTypes.bool
}

export default DangerDialog
